import ApprovalLogs from '../views/ApprovalLogs/approvalLogs';

export default [
	{
		path: '/approvallogs',
		name: 'approvalLogs',
		component: ApprovalLogs,
		title: 'approvalLogs',
		meta: {
			requiresAuth: true
		  }
	}

];



// WEBPACK FOOTER //
// ./src/modules/reporting/router/index.js